import { Component } from "react";
import styles from "../FormSubmissionReplies/FormSubmissionReplies.module.scss";
import { Input3, Button2, ThankYouSection, ErrorSection, Checkbox, BackButton, SearchBar } from "..";
import {
  STAGES,
} from "./constants";
import { EMAIL_REGEX, BEATBREAD_PRIVACY_POLICY } from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import * as Yup from "yup";
import { ReactComponent as Arrows } from "../../assets/SVGs/double-chevron-right.svg";
import { API_URL, ARTIST_ONLY, TERM_OF_USE, USER_API } from "../../routes/constants";
import { Form, Formik } from "formik";
import MultipleUploads from "../../pages/SinglePageSignup/MultipleDistributorUpload/MultipleDistributorUpload";
import { toast } from "react-toastify";
import request from "../../utils/request";
import segment from "../../utils/segment";

class PublishingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedFormData: {
        reportsChecked: false,
        checked: false,
        name: "",
        role: "",
        email: "",
      },
      id: "",
      image:"",
      artistName:"",
      alertText: "",
      stage: STAGES.INITIAL,
      publisherFiles: {},
      spotifyId: false,
      searchType: "name",
      loader: false,
    };

    this.updatedPublisherFiles = this.updatedPublisherFiles.bind(this);
  }

  resetState = (additionalStates = {}) => {
    this.setState({
      updatedFormData: {
        reportsChecked: false,
        checked: false,
        name: "",
        role: "",
        email: "",
      },
      id: "",
      alertText: "",
      stage: STAGES.INITIAL,
      publisherFiles: {},
      spotifyId: false,
      searchType: "name",
      loader: false,
      ...additionalStates,
    });
  };

  changeComponentErr = (alertText) => {
    return <ErrorSection onClick={this.renderInitial} subtitle={alertText} />;
  };

  changeComponentSuc = () => {
    return (
      <ThankYouSection subtitle="We are reviewing the information that you provided. We'll be in touch in the next few days." />
    );
  };

  renderSearchBar = () => (
    <SearchBar label="Primary Artist in Catalog:"standalone onUpdateArtist={(e) => this.updateArtist(e)}/>
  );

  publisherSchema = Yup.object().shape({
    id: Yup.string().required("Please select a publisher."),
    files: Yup
      .array()
      .min(1, 'Each publisher must have at least one file uploaded.')
      .of(Yup.mixed().required()),
  });
  
  validationFormSchema = Yup.object().shape({
    id: Yup.string().required("Please select your primary artist."),
    publisherFiles: Yup
      .array()
      .min(1, 'Please upload at least one publishing report.')
      .of(this.publisherSchema),
    
  });

  emailValidation = () => EMAIL_REGEX;

  handleSubmit = async (values) => {
    this.setState({ loader: true });
    const { publisherFiles, id, reportsChecked} = this.state;
    const formPayload = {
      id: id || null,
      reportsChecked: reportsChecked || null,
      publisherFiles: Object.values(publisherFiles),
    };
    try {
      await this.validationFormSchema.validate(formPayload, { abortEarly: true });
    } catch (err) {
      toast.error(err?.message);
      this.setState({ loader: false });
      return;
    }
    const formData = new FormData();
    formData.append("email", values.email);
    formData.append("spotifyId", id);
    formData.append("name", values.name);
    formData.append("role", values.role);
    formData.append("rights_type", '["Publishing"]');
    Object.values(publisherFiles).forEach((pubData) => {
      const { files = [] } = pubData;
      files.forEach((file) => {
        if (file && file.name) {
          formData.append(pubData.id, file, file.name);
        }
      });
    });
    const data = {
      method: "PUT",
      body: formData,
      headers: { "Access-Control-Allow-Origin": "*" },
    };
    const requestURL = `${API_URL}${USER_API}${ARTIST_ONLY}`;
    request(requestURL, data)
      .then(() => {
        this.setState({ loader: false });
        const reportDetails = Object.values(publisherFiles).map((d) => ({
          distributorName: d.name,
        }));
        segment.track.directSignup({ reportDetails });
        this.setState({ stage: "success" });
      })
      .catch((err) => {
        this.setState({ loader: false });
        this.setState({ alertText: err.message });
        this.setState({ stage: "error" });
      });
  };

  updatedPublisherFiles(publisherFiles) {
    this.setState({ publisherFiles });
  }

  handleSelectChange = () => {
    this.setState(
      (prevState) => ({ spotifyId: !prevState.spotifyId }),
      () => {
        if (this.state.spotifyId) {
          this.setState({ searchType: "id" });
        } else {
          this.setState({ searchType: "name" });
        }
      }
    );
  };

  updateArtist = (e) => {
    if (e) {
      if (e.value) {
        document.getElementsByClassName(
          "select-search__input-container"
        )[0].style.display = "none";
      }
      this.setState({ id: e.value, artistName: e.label, image: e.imageUrl });
    }
  };

  handleBackNavigation = () => {
    if (this.state.stage !== STAGES.INITIAL) {
      return (
        <BackButton onClick={() => this.setState({ stage: STAGES.INITIAL })} />
      );
    }
  };

  renderWidgetForm = () => (
    <Formik
      initialValues={this.state.updatedFormData}
      validationSchema={this.formikValidation}
      onSubmit={this.handleSubmit}
    >
      {({ values, errors, touched, setFieldValue }) => (
        <Form className={styles.widgetBoxForm}>
          <div className={styles.heading}>
            <p className={styles.ogSubtitle}>
              Interested in accessing your publishing revenue with beatBread?
            </p>
            <h2 className={styles.ogTitle}>
              Share a few details and we’ll be in touch.
            </h2>
          </div>
          <div className={styles.form}>
            <Input3
              title="Contact Name"
              name="name"
              autoComplete="name"
              placeholder="Enter Name"
              disabled={this.state.loader}
            />
            <div className={styles.search}>
              {this.renderSearchBar()}
              <Input3
                title="Email"
                name="email"
                autoComplete="email"
                placeholder="Enter Email"
                disabled={this.state.loader}
              />
            </div>
            <Input3
              input="dropdown"
              title="I am..."
              name="role"
              options={[
                "A Songwriter/Producer",
                "A Songwriter and Recording Artist",
                "A Recording Artist Only",
                "An Artist, Writer or Producer Representative",
                "Other",
              ]}
              disabled={this.state.loader}
            />
          </div>
          <MultipleUploads
            updateFiles={this.updatedPublisherFiles}
            type={"Publisher"}
          />
          <div className={styles.checkboxClass}>
            <Checkbox input="checkbox" name="reportsChecked">
              <div className={styles.checkLabel}>
                  I’ve uploaded 2 years worth of reports for each work that I want to include in my advance offer.
              </div>
            </Checkbox>
          </div>
          <div className={styles.checkboxClass}>
            <Checkbox input="checkbox" name="checked">
              <div className={styles.checkLabel}>
                I agree to beatBread’s{" "}
                <a href={TERM_OF_USE} target="_blank" rel="noreferrer">
                  Terms of Service
                </a>{" "}
                and acknowledge beatBread’s{" "}
                <a
                  href={BEATBREAD_PRIVACY_POLICY}
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Notice
                </a>
                . I consent to receive beatBread messages via SMS. Standard
                call, message, or data rates may apply.
              </div>
            </Checkbox>
          </div>
          <Button2
            full
            lg
            className={styles.submit}
            type="submit"
            disabled={this.state.loader}
          >
            {this.state.loader ? (
              <FontAwesomeIcon icon={faCircleNotch} className="spin" />
            ) : (
              <>
                <p>SUBMIT</p> <Arrows />
              </>
            )}
          </Button2>
        </Form>
      )}
    </Formik>
  );

  renderInitial = () =>
    this.setState({
      stage: STAGES.INITIAL,
    });

  formikValidation = Yup.object().shape({
    name: Yup.string()
      .label("Contact Name")
      .required("Please enter your name."),
    email: Yup.string()
      .label("Email")
      .required("Please enter your email.")
      .matches(EMAIL_REGEX, "Please enter a valid email."),
    role: Yup.string().label("Role").required("Please select your role."),
    checked: Yup.bool().required().oneOf(
      [true],
      "Please agree to the Terms of Service and Privacy Notice to proceed."
    ),
    reportsChecked: Yup.bool().required().oneOf(
      [true],
      "Please confirm that you have uploaded 6 months of reports."
    ),
  });

  setStage = () => {
    switch (this.state.stage) {
      case STAGES.INITIAL:
        return this.renderWidgetForm();
      case STAGES.SUCCESS:
        return this.changeComponentSuc();
      case STAGES.ERROR:
        return this.changeComponentErr(this.state.alertText);
      default:
        return this.renderWidgetForm();
    }
  }

  render() {
    return (
      <div className={styles.DealCompForm}>
        {this.setStage()}
        {this.handleBackNavigation()}
      </div>  
    );
  }
}

export default PublishingForm;
